import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { cancelSubscription } from 'src/services/subscriptionApi'

export const useCancelSubscriptionMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: cancelSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_SUBSCRIPTION_STATUS],
      })
    },
  })
}
